module.exports = __webpack_public_path__ + "02e317b1c536cd51e3b6c3dd6194dc7e.png";